@if (('task.view'|HasPerm) || ('task.offer.view'|HasPerm)) {
  <a uiSref="a.workflow.new" title="Neuer Vorgang" class="btn btn-default" [uiOptions]="{reload: true}"
    >
    <span class="fa fa-plus"></span>
  </a>
}
